import React from "react";
import { Link } from "react-router-dom";
import socLogo from "../../images/aicpa-soc-logo.png";
import hipaaBadge from "../../images/hipaa-compliant-badge.svg";

// The AICPA logo must not be altered except for size: only height is set.
export const AicpaLogo = ({ height = 68 }) => (
  <a href="https://www.aicpa.org/soc4so" target="_blank" rel="noopener noreferrer">
    <img src={socLogo} alt="AICPA SOC for Service Organizations logo" style={{ height, width: "auto" }} />
  </a>
);

export const HipaaBadge = ({ height = 68 }) => (
  <Link to="/security">
    <img src={hipaaBadge} alt="HIPAA Compliant" style={{ height, width: "auto" }} />
  </Link>
);

const TrustBadges = ({ justify = "center", height = 68, linkColor = "#fff", linkShadow = false }) => (
  <div className="trust-badges my-2">
    <div
      className="d-flex flex-wrap align-items-center"
      style={{ gap: "24px", justifyContent: justify }}
    >
      <AicpaLogo height={height} />
      <HipaaBadge height={height} />
    </div>
    <div className="mt-2" style={{ textAlign: justify === "center" ? "center" : "left" }}>
      <Link
        to="/security"
        style={{ color: linkColor, textDecoration: "underline", fontSize: "0.95rem", textShadow: linkShadow ? "0 1px 3px rgba(0,0,0,0.9), 0 0 6px rgba(0,0,0,0.6)" : undefined }}
      >
        Security &amp; Compliance
      </Link>
    </div>
  </div>
);

export default TrustBadges;

// Floats the badges over a hero image (parent must be position: relative).
// Desktop: top-right. Mobile: top-centre, with an in-flow spacer so content clears it.
export const useIsMobile = () => {
  const get = () => window.innerWidth < 768;
  const [m, setM] = React.useState(get());
  React.useEffect(() => {
    const f = () => setM(get());
    window.addEventListener("resize", f);
    return () => window.removeEventListener("resize", f);
  }, []);
  return m;
};

export const HeroBadgeOverlay = () => {
  const mobile = useIsMobile();
  return (
    <>
      {mobile && <div style={{ height: "5.5rem" }} aria-hidden="true" />}
      <div
        style={{
          position: "absolute",
          top: 12,
          zIndex: 5,
          ...(mobile ? { left: 0, right: 0 } : { right: 24 }),
        }}
      >
        <TrustBadges height={mobile ? 52 : 72} linkColor="#fff" linkShadow justify={mobile ? "center" : "flex-end"} />
      </div>
    </>
  );
};
